

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"120","height":"120","viewBox":"0 0 120 120","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('path', {"d":"M49.154 36.503c-1.087.12-1.91 1.087-1.904 2.238v11.935H28.126a2.198 2.198 0 00-.222 0c-1.087.12-1.91 1.088-1.904 2.238v28.348c0 1.236.952 2.238 2.126 2.238h63.749c1.174 0 2.125-1.002 2.125-2.238V61.866c0-1.236-.951-2.238-2.125-2.238H72.75V38.741c0-1.236-.951-2.238-2.125-2.238h-21.25a2.184 2.184 0 00-.221 0","fill":"#FFF","fill-rule":"evenodd"}, [])]);
};

        